import { ExpressionNode } from "./ast";

const walk = (exp: ExpressionNode | void, keyPath: string[] = []): string[] => {
  if (!exp?.identifier) {
    return keyPath;
  }

  const next = exp.identifier.value.trim();

  return walk(exp.property, [...keyPath, next]);
};

export const getExpressionKeyPath = (expression: ExpressionNode): string[] => {
  return walk(expression);
};
